export default __webpack_public_path__ + "static/media/connect-icon.dd5c4765.png";